module.exports = __webpack_public_path__ + "img/aniversario.8b3379e1.webp";